// extracted by mini-css-extract-plugin
export var activeLink = "header-module--activeLink--7c4cb";
export var headerLogo = "header-module--headerLogo--2a6df";
export var logoCircle = "header-module--logoCircle--78016";
export var logoText = "header-module--logoText--2a622";
export var menu = "header-module--menu--4f3a7";
export var menuLink = "header-module--menuLink--b2a71";
export var spin = "header-module--spin--47dd0";